import { ArrowLeftOutlined } from "@ant-design/icons";
import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import logo from "../../assets/ekdom-logo-1.svg";

const ErrorPage = ({ goToHome }) => {
    return (
        <div
            className="page-error"
            style={{ justifyContent: "center" }}
            data-testid="page404-component"
        >
            <div className={"page-error--content"}>
                <div>
                    <img src={logo} alt="logo" />
                </div>
                <div className="page-error--desc">
                    Désolé, une erreur s'est produite.
                </div>
                <Button
                    type={"primary"}
                    onClick={goToHome}
                    className="page-error--btn"
                    icon={<ArrowLeftOutlined />}
                >
                    Retour à l'accueil
                </Button>
            </div>
        </div>
    );
};

ErrorPage.propTypes = {
    goToHome: PropTypes.func.isRequired
};

export default ErrorPage;
